import {getLastElementOr, showlog} from "../../../utils";
import {saveAs} from "file-saver";
import moment from "moment/moment";
import {DATETIME_FORMAT_IT} from "../../../conf";
import React, {MouseEvent, useEffect, useState} from "react";
import {ArticleComponent} from "./ArticleComponent";
import {articleFieldMap} from "../static";

type CheckupData = {
	versioneConnettore: string | null;
	versioneESolver: string | null;
	porte: Array<{ numero: string, avviabile: boolean }>;
};

function parseCheckupHtml(html: string): CheckupData {
	const connettoreMatch = html.match(/VERSIONE CONNETTORE:\s*<\/b>\s*([\d.]+)/);
	const eSolverMatch = html.match(/VERSIONE eSolver:\s*<\/b>\s*([^<\s]+)/);

	const porte: Array<{ numero: string, avviabile: boolean }> = [];
	const portMatches = html.matchAll(/PORTA\s+(\d+)\s+(AVVIABILE|NON AVVIABILE)/g);
	for (const match of portMatches) {
		porte.push({
			numero: match[1],
			avviabile: match[2] === 'AVVIABILE'
		});
	}

	return {
		versioneConnettore: connettoreMatch ? connettoreMatch[1] : null,
		versioneESolver: eSolverMatch ? eSolverMatch[1] : null,
		porte: porte,
	};
}

type Props = {
	order: any
	onDownloadOrderPress: (event: MouseEvent<HTMLImageElement>) => void
	onCurlRequestPress: (event: MouseEvent<HTMLImageElement>) => void
	onConnectorPress: (event: MouseEvent<HTMLImageElement>) => void
}

export function OrderComponent(props: Props) {
	const {
		order,
		onDownloadOrderPress,
		onCurlRequestPress,
		onConnectorPress
	} = props;

	const [openArticlePanel, setOpenArticlePanel] = useState<any[]>([]) // TODO type
	const [checkupData, setCheckupData] = useState<CheckupData | null>(null);
	const [checkupLoading, setCheckupLoading] = useState(false);
	const [checkupError, setCheckupError] = useState<string | null>(null);

	const fetchCheckup = () => {
		const syncUrl = order.operatorSyncUrl;
		if (!syncUrl || syncUrl === 'no-url') return;
		setCheckupLoading(true);
		setCheckupError(null);
		const encodedUrl = btoa(syncUrl);
		fetch(`/mobileagent/proxy/checkup?url=${encodedUrl}`)
			.then(res => res.text())
			.then(html => {
				setCheckupData(parseCheckupHtml(html));
				setCheckupLoading(false);
			})
			.catch(() => {
				setCheckupError('Impossibile raggiungere il connettore');
				setCheckupLoading(false);
			});
	};

	useEffect(() => {
		fetchCheckup();
	}, []);

	// console.log('OrderComponent', order);
	// let order: any = this.state.orders[oIndex];
	let totNettoMerci;
	let totImponibile;
	let totOmaggi;
	let totScontoMerce;
	let qtTot = 0;

// debugger;

	try {

		let fieldToCheck = ["type", "key", "ref", "props", "_owner"];
		order.payload.items
			.map(it => {
				Object.keys(it)
					.map(itField => {
						if (!!it[itField]) {
							if (
								Object.keys(it[itField])
									.filter(field => fieldToCheck.includes(field))
									.length === fieldToCheck.length
							) {
								delete it[itField];
							}
						}
					})
				;
				return it;
			})
		;


		totNettoMerci = order.payload.items.reduce((totale, data) => {
			let qt = data.qt;
			totale += parseFloat(data.details.prezzoNettoSconti) * qt;
			return totale;
		}, 0);

		totImponibile = parseFloat(totNettoMerci);
		totImponibile -= (totImponibile * parseFloat(order.paymentPercSconto || 0) / 100);


		order.payload.items
			.forEach(art => {
				qtTot += parseFloat(art.qt)
			})
		;

		totOmaggi = order.payload.items.reduce((totale, data) => {
			return totale + parseFloat(data.details.omaggio);
		}, 0);
		totScontoMerce = order.payload.items.reduce((totale, data) => {
			return totale + parseFloat(data.details.scontoMerce);
		}, 0);


		totNettoMerci = parseFloat(totNettoMerci).toFixed(2);
		totImponibile = parseFloat(totImponibile).toFixed(2);


// debugger;

	} catch (e) {
		showlog("errore");
		showlog(e);
		debugger;

	}


	return (
		<div className={"order-page-row-content"}>

			<h4
				onClick={(clickEvent) => {
					let file = new Blob([JSON.stringify(order)], {type: "text/json;charset=utf-8"});
					saveAs(file, `Ordine ${order.dbID || order._id}.json`);
				}}
			>
				DB ID: {order.dbID || order._id}
				<img
					src={'/imgs/save.png'}
					className={"download-order order-icon-themed"}
					title={"Scarica JSON ordine"}
				/>
				<img
					src={'/imgs/info.png'}
					className={"download-order order-icon-themed"}
					title={"Visualizza JSON ordine"}
					onClick={onDownloadOrderPress}
				/>
				<img
					src={'/imgs/postman-icon.svg'}
					className={"download-order"}
					title={"Ottieni chiamata Postman"}
					onClick={onCurlRequestPress}
				/>
				<img
					src={'/imgs/power.svg'}
					className={"download-order order-icon-themed"}
					title={"Ottieni payload connettore"}
					onClick={onConnectorPress}
				/>
			</h4>


			<div className={"order-page-customer-order"}> {/* ---- sezione cliente/ordine ---- */}
				<div className={"order-page-order"}>
					<div><label>ID</label><span>{order.payload?.documentId || ""}</span></div>
					<div><label>Documento</label><span
						className={"light-color bold-text"}>{order.payload?.documentNumber || ""}</span>
					</div>
					<div><label>Data
						Ordine</label><span>{!!order.payload ? moment.unix(parseInt(order.payload.startOrderTime, 10) / 1000).format(DATETIME_FORMAT_IT) : "-"}</span>
					</div>
					<div><label>Data</label><span>{order.moment}</span></div>
					<div className={""}><label>Netto</label><span>{totNettoMerci} €</span></div>
					<div className={"netto"}><label>Imponibile</label><span>{totImponibile} €</span></div>
					<div><label>IVA</label><span>{"TODO"}</span></div>
					<div><label>Addebiti</label><span>{"TODO"}</span></div>
					<div><label>Omaggi</label><span>{totOmaggi}</span></div>
					<div><label>Sconto Merce</label><span>{totScontoMerce} %</span></div>
					<div><label>Numero Articoli</label><span>{order.itemsMagnitude}</span></div>
					<div className={"netto"}><label>Totale Qt</label><span>{qtTot}</span></div>
					<div><label>Totale</label><span>{"TODO"}</span></div>

					<div>
						<label>Condizione di pagamento</label>
						<span>{"(" + order.payload?.paymentCondition?.codCondizPagamento + ") " + order.payload.paymentCondition?.des + " -"}</span>
						<br/>
						<span> &nbsp;{(order.payload?.paymentCondition?.percSconto || 0) + "% "}</span>
					</div>
					<div><label>Status</label><span>{!!order.payload ? order.payload?.status : "-"}</span></div>

					<div><label>Agente</label>
						<span>{order.operatorId + " " + order.operatorUsername + " " + order.operatorSyncUrl}</span>
					</div>
					<div><label>Dispositivo</label> <span>{order.device}</span></div>

					<div
						className={"order-note"}>{(!!order.payload && !!order.payload.customer && !!order.payload.customer.note) ? order.payload.customer.note : "Note: nessuna"}</div>
				</div>

				<div className={"order-page-customer"}>
					<div>
						<div>
							<div
								className={"order-customer-name " + (
									(!!order.payload && !!order.payload.TipoAnagrafica && (order.payload.TipoAnagrafica == 6))
										? "potential-customer"
										: ""
								)
								}
							>
								<strong>{order.payload?.customer?.ragioneSociale}</strong>
							</div>

							<div><strong>Indirizzo di consegna</strong>
								{
									(!!order.payload && !!order.payload.deliveryAddress)
										? (order.payload.deliveryAddress.via + ", " + order.payload.deliveryAddress.comune + ", " + order.payload.deliveryAddress.cap)
										: "-"
								}
							</div>

							<div></div>
							<div><strong>PEC</strong>{!!order.payload ? order.payload.PEC : "-"}</div>
							<div><strong>SDI</strong>{!!order.payload ? order.payload.SDI : "-"}</div>
							<div><strong>annotations</strong>{"TODO"}</div>
							<div><strong>categoria</strong>{!!order.payload ? order.payload.categoria_name : "-"}
							</div>
							<div><strong>categoria
								sconti</strong>{!!order.payload ? order.payload.categoria_sconti : "-"}</div>
							<div><strong>codice
								fiscale</strong>{!!order.payload ? order.payload.codice_fiscale : "-"}</div>
							<div><strong>commercialCondition</strong>{"TODO"}</div>
							<div><strong>condizioni commerciali
								multiple</strong>{!!order.payload ? (!!order.payload.cond_com_per_indirizzo ? "true" : "false") : "-"}
							</div>
							<div><strong>email</strong>{!!order.payload ? order.payload.email : "-"}</div>
							<div><strong>piva</strong>{!!order.payload ? order.payload.piva : "-"}</div>
							<div><strong>telefono</strong>{!!order.payload ? order.payload.telefono : "-"}</div>
							<div><strong>tipologia
								commerciale</strong>{!!order.payload ? order.payload.tipologia_commerciale : "-"}
							</div>
							<div><strong>ultimo
								progressivo</strong>{!!order.payload ? order.payload.ultimoProgressivo : "-"}</div>
							<div><strong>sito web</strong>{!!order.payload ? order.payload.web_site : "-"}</div>
							<div><strong>zona</strong>{!!order.payload ? order.payload.zona : "-"}</div>

							<div></div>

							<div><strong>Data di Consegna</strong> {order.deliveryDate}</div>
							<div><strong>Sconto Pagamento</strong>{order.paymentPercSconto}</div>

							<div><strong>Fido</strong> {"TODO"}</div>
							<div><strong>Scadenze</strong> {"TODO"}</div>
						</div>
					</div>

				</div>

			</div>

			<div className={"order-page-info"}>
				<div><label>Ultima Sync</label><span>{order.lastSync}</span></div>
				<div><label>Indirizzo IP</label><span>{order.ipv4 || "0.0.0.0"}</span></div>
			</div>

			<div className={"order-page-info"}>
				<div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
					<label>Checkup connettore</label>
					<span
						title={"Ricarica checkup"}
						style={{cursor: 'pointer', fontSize: '16px'}}
						onClick={(e) => { e.stopPropagation(); fetchCheckup(); }}
					>&#x21BB;</span>
				</div>
				{checkupLoading && <span style={{color: 'gray'}}>Caricamento...</span>}
				{checkupError && <span style={{color: 'red'}}>{checkupError}</span>}
				{!!checkupData && !checkupLoading && (
					<>
						<div>
							<label>Ver. Connettore</label>
							<span>{checkupData.versioneConnettore ?? '-'}</span>
						</div>
						<div>
							<label>Ver. eSolver</label>
							<span>{checkupData.versioneESolver ?? '-'}</span>
						</div>
						{checkupData.porte.map((p, i) => (
							<div key={i}>
								<label>Porta {p.numero}</label>
								<span style={{
									color: 'white',
									background: p.avviabile ? 'green' : 'red',
									padding: '2px 6px',
									borderRadius: '4px'
								}}>
									{p.avviabile ? 'Avviabile' : 'Non avviabile'}
								</span>
							</div>
						))}
					</>
				)}
			</div>

			{
				(!!order.payload && !!order.payload.items) && (
					<React.Fragment>
						<code>ARTICOLI</code>
						<br/>
						<table>
							<thead>
							<tr>
								{
									// tutti i campi
									Object.keys(order.payload.items.reduce(getLastElementOr, []))

										// solo campi voluti
										.filter((articleField: string, articleFieldIndex: number) => Object.keys(articleFieldMap).includes(articleField))

										// nome campi
										.map((articleField: string, articleFieldIndex: number): string => articleFieldMap[articleField])

										// campi in HTML
										.map((articleField: string, articleFieldIndex: number) => (
											<th
												onClick={(clickEvent: any) => {
													// TODO ordinamento
												}}
											>
												{articleField}
											</th>
										))

								}
							</tr>
							</thead>
							<tbody>
							{
								order.payload.items
									.map((article: any, articleIndex: number) => [article, undefined])
									.flatMap((article: any, articleIndex: number) => {
										showlog('riga articolo ', article);
										return article;
									})
									.flatMap((article: any, articleIndex: number) => (
										<tr
											onClick={(clickEvent: any) => {
												if (openArticlePanel.includes(articleIndex)) {
													setOpenArticlePanel(openArticlePanel.filter((op: any) => op !== articleIndex))
												} else {
													showlog('inserimento in openArticlePanel', articleIndex);
													setOpenArticlePanel([...openArticlePanel, articleIndex])
												}

											}}
											className={((articleIndex % 4) === 0) ? 'even-row' : 'odd-row'}
										>
											{

												!!article
													? (
														// tutti i campi
														Object.keys(article)

															// solo campi voluti
															.filter((articleField: string, articleFieldIndex: number) => Object.keys(articleFieldMap).includes(articleField))

															// campi in HTML
															.map((articleField: string, articleFieldIndex: number) => (
																<td>{article[articleField]}</td>
															))
													)
													: (
														// @ts-ignore
														openArticlePanel.includes(articleIndex - 1) && (
															<td
																colSpan={
																	Object.keys(order.payload.items.reduce(getLastElementOr, []))

																		// solo campi voluti
																		.filter((articleField: string, articleFieldIndex: number) => Object.keys(articleFieldMap).includes(articleField))

																		// nome campi
																		.map((articleField: string, articleFieldIndex: number): string => articleFieldMap[articleField])

																		.length
																}
															>
																{/*{this.articleRenderer((articleIndex - 1) / 2, oIndex)}*/}
																{
																	<ArticleComponent
																		article={
																			(order?.payload?.items || [])
																				.filter((it: any, itIndex: number) => itIndex === ((articleIndex - 1) / 2))
																				.reduce(getLastElementOr, null)
																		}
																	/>
																}
															</td>
														)
													)
											}
										</tr>
									))
							}
							</tbody>
						</table>


					</React.Fragment>
				)
			}
		</div>
	);
}
